interface data {
  id: string;
  communityId: string;
  billingAddressCity: string;
  billingAddressState: string;
  billingAddressStreet: string;
  billingZipCode: string;
  creditCardExpirationDt: string;
  creditCardNumber: string;
  creditCardToken: string;
  creditCardType: string;
  nameOnCard: string;
  paymentPlan: 'MONTHLY' | 'ANNUAL';
}

export const BIND_POLICY = (data: data) => {
  return `mutation {
        bindPolicy(
          applicationId: "${data.id}",
          input: {
            communityId: "${data.communityId}",
            billingAddressCity: "${data.billingAddressCity}",
            billingAddressState: "${data.billingAddressState}",
            billingAddressStreet: "${data.billingAddressStreet}",
            billingZipCode: "${data.billingZipCode}",
            creditCardExpirationDt: "${data.creditCardExpirationDt}",
            creditCardNumber: "${data.creditCardNumber}",
            creditCardToken: "${data.creditCardToken}",
            creditCardType: "${data.creditCardType}",
            nameOnCard: "${data.nameOnCard}",
            paymentPlan: ${data.paymentPlan},
          }
        ) {
          ... on ApplicationOutput {
            id,
            applicationDate,
            completedAt,
            coverageEnd,
            policyAmount,
            policyExpirationDate,
            policyNumber,
            policyStatusCd,
            price,
            provider,
            status,
            paymentPlans {
              paymentPlanCd,
              installmentPaymentAmount,
              totalPremiumAmt,
              downPaymentAmount,
              installmentFeeAmount,
              installmentAmount
            }
          }
          ... on ErrorListOutput {
            errors: errors {
                type
                message
            }
          }
        }
       
      }
    `;
};
